import React, { useState } from 'react';
import { UserPlus, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useApp } from '../context/AppContext';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from './ui/dropdown-menu';
import { cn } from '../lib/utils';

export function ReassignMenu({ assessment, label = 'Reassign', className, iconOnly = false }) {
  const app = useApp();
  const [list, setList] = useState(null);
  const [busy, setBusy] = useState(false);
  if (!app.hasCap('release_claims')) return null;
  const load = async (open) => { if (open && list === null) setList(await app.getReviewers(assessment.id)); };
  const pick = async (u) => {
    setBusy(true);
    const r = await app.reassign(assessment.id, u.id);
    setBusy(false);
    if (r) toast.success(`Handed to ${u.name} — they have been notified`);
  };
  const holder = assessment.meta?.claimedBy;
  return (
    <DropdownMenu onOpenChange={load}>
      <DropdownMenuTrigger asChild>
        <button type="button" data-testid={`reassign-${assessment.id}`} title="Hand this claim to a named reviewer" className={cn('inline-flex items-center gap-1 text-xs text-ink-500 hover:text-ink-800 transition-colors', className)} disabled={busy}>
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <UserPlus className="h-3.5 w-3.5" />}{!iconOnly && label}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="text-xs">Hand to…</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {list === null && <div className="px-2 py-2 text-xs text-ink-400">Loading reviewers…</div>}
        {list && list.length === 0 && <div className="px-2 py-2 text-xs text-ink-400">No eligible reviewer for this class.</div>}
        {list && list.filter((u) => u.name !== holder).map((u) => (
          <DropdownMenuItem key={u.id} data-testid={`reassign-to-${u.id}`} onClick={() => pick(u)} className="flex items-center gap-2">
            <span className="h-6 w-6 rounded-full bg-ink-100 text-ink-700 text-[10px] font-semibold flex items-center justify-center shrink-0">{u.name.split(' ').map((p) => p[0]).slice(0, 2).join('')}</span>
            <span className="min-w-0 flex-1"><span className="block text-sm text-ink-800 truncate">{u.name}</span><span className="block text-[11px] text-ink-400 truncate">{u.role}</span></span>
            <span className={cn('text-[11px] tabular-nums', u.openClaims ? 'text-ink-500' : 'text-emerald-600')}>{u.openClaims} open</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
